import { Chip } from "@mui/material";
import { s3baseUrl } from "src/config/config";
import { htmlDecode } from "src/utils/convertHtml";
import { useNavigate } from "react-router-dom";
import moment from "moment";

export default function ProgrammeListMemberProfile({
  programmes,
  Id,
  member_vdot,
  memberAllDetails,
}) {
  const navigate = useNavigate();

  const handleNavigateDetail = (value) => {
    const programmeId = value._id._id;
    navigate(`/member/${Id}/member-MemberCalendar/${programmeId}`);
  };

  return (
    <>
      <div className="col-12">
        <h2 className="mb-0">Programme </h2>
      </div>
      {programmes?.map((value, index) => {
        return (
          <>
            <div className="col-lg-4 col-md-4 col-sm-12 mb-4" key={index}>
              <div className="card mt-4 pods-cards-shadow cursor h-100">
                <img
                  src={s3baseUrl + value?._id?.program_images?.thumbnail_1}
                  className="card-img-top pods-image"
                  alt="Programme"
                  onClick={() => handleNavigateDetail(value)}
                />
                <div className="card-body">
                  <div className="row">
                    <div className="col-12">
                      <h3
                        className="h2-heading"
                        onClick={() => handleNavigateDetail(value)}
                      >
                        {htmlDecode(value._id.title)}
                      </h3>
                    </div>
                  </div>
                  <p className="programme-card-desc mb-3">
                    {htmlDecode(value._id.short_description)}
                  </p>
                  {value?.review_date ? (
                    <Chip
                      label={`Review Date: ${moment(value?.review_date).format(
                        "DD-MM-YYYY",
                      )}`}
                      color="primary"
                      sx={{
                        borderRadius: "5px",
                      }}
                    />
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </div>
          </>
        );
      })}
    </>
  );
}
